import { render } from "./AdminDashboardPage.vue?vue&type=template&id=6075b446"
import script from "./AdminDashboardPage.vue?vue&type=script&lang=js"
export * from "./AdminDashboardPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__